/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import React from "react"
import Helmet from "react-helmet"
import { useSelector } from "react-redux"

import { getFont, getBannerFont } from "../helpers"

const { REACT_APP_DOMAIN_ZONE: domainZone, REACT_APP_BRAND: brand, REACT_APP_DOMAIN_URL: domainUrl } = process.env

const country = domainZone.includes("-") ? domainZone.substring(0, domainZone.lastIndexOf("-")) : domainZone

const isIndexed = process.env.REACT_APP_IS_INDEXED === "true" // domainZone.includes("-") && domainZone.split("-")[1] === "eu"

const gtmEnabledZones = ["nz", "it", "cl"]

const Head = () => {
  const translations = useSelector(state => state.data.translations) // ✅ from RTK slice
  const homePage = useSelector(state => state.data.homePage) // ✅ from RTK slice

  const shouldUseGtm = domainZone && gtmEnabledZones.includes(country.toLowerCase())

  const mainFont = getFont(brand)
  const bannerFont = getBannerFont(brand)

  const { metaTitle, metaDescription } = homePage || {}

  const canonicalUrl = domainZone === "it" ? `${domainUrl}/${domainZone}` : `${domainUrl}`

  return (
    <Helmet
      htmlAttributes={{
        class: `theme theme-${brand}`
      }}
    >
      <title>{metaTitle || translations?.metaTitle}</title>
      {metaDescription && <meta name="description" content={metaDescription} />}
      {isIndexed && <link rel="canonical" href={canonicalUrl} />}
      {!isIndexed && <meta name="robots" content="noindex, nofollow" />}
      {!isIndexed && <meta name="googlebot" content="noindex, nofollow" />}
      {!isIndexed && <meta name="AdsBot-Google" content="noindex, nofollow" />}
      {!isIndexed && <meta name="google-site-verification" content="eETJvGQNvFMj8ByGiqfcpX7G4Z1niDE2Me_JRnASnlk" />}
      {!isIndexed && <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <script>
        {shouldUseGtm &&
          `window.dataLayer = window.dataLayer || [];
            function gtag() {dataLayer.push(arguments);}
            if (localStorage.getItem('consentMode') === null){
              gtag('consent', 'default', {
                'ad_storage': 'denied',
                'analytics_storage': 'denied',
                'personalization_storage': 'denied',
                'functionality_storage': 'denied',
                'security_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied'
              })
            } else {
              gtag ('consent', 'default', JSON.parse(localStorage.getItem('consentMode')))
            }`}
      </script>
      <link href={mainFont} rel="stylesheet" />
      <link href={bannerFont} rel="stylesheet" />
      <link rel="icon" href={require(`../assets/${brand}/favicon.ico`)} type="image/x-icon" />
      <link rel="shortcut icon" href={require(`../assets/${brand}/favicon.ico`)} type="image/x-icon" />
    </Helmet>
  )
}

export default Head
